import { render } from "./ModulInfoBildText2Spaltig.vue?vue&type=template&id=ee524f8c"
import script from "./ModulInfoBildText2Spaltig.vue?vue&type=script&lang=js"
export * from "./ModulInfoBildText2Spaltig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__